"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _diamond = require("@/api/basic/diamond");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'consumeOrder',
  components: {},
  data: function data() {
    return {
      systemStatuslist: [{
        id: 0,
        name: '审核中'
      }, {
        id: 1,
        name: '审核通过'
      }, {
        id: 2,
        name: '审核未通过'
      }, {
        id: 4,
        name: '复审通过'
      }, {
        id: 3,
        name: '复审未通过'
      }],
      statusList: [{
        id: 0,
        name: '审核中'
      }, {
        id: 1,
        name: '审核通过'
      }, {
        id: 2,
        name: '审核未通过'
      }, {
        id: 3,
        name: '申诉中'
      }, {
        id: 4,
        name: '申诉不通过'
      }, {
        id: 5,
        name: '申诉通过'
      }, {
        id: 6,
        name: '已领取'
      }, {
        id: 7,
        name: '已降级'
      }, {
        id: 8,
        name: '审核终止'
      }],
      dialogTitle: '审核通过',
      loading: false,
      activeTab: 'wxOrder',
      searchForm: {
        systemStatus: '',
        cardNo: '',
        status: '',
        mobile: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [{
        id: 1,
        title: '活动名称',
        couponBame: '饮品五折券',
        shareCouponName: '整单85折',
        extraReward: '50积分',
        actTime: '2020-12-01 10:10:10-2020-12-31 23:59:59',
        totalNum: '1000',
        expanding: '500',
        expandComplete: '400',
        expandFail: '100',
        actStatus: '未启用',
        registerNum: '200'
      }, {
        id: 2,
        title: '活动名称',
        couponBame: '饮品五折券',
        shareCouponName: '整单85折',
        extraReward: '50积分',
        actTime: '2020-12-01 10:10:10-2020-12-31 23:59:59',
        totalNum: '1000',
        expanding: '500',
        expandComplete: '400',
        expandFail: '100',
        actStatus: '启用',
        registerNum: '200'
      }],
      showAddDialog: false,
      addForm: {
        remark2: ''
      },
      addFormRules: {
        remark2: [{
          required: true,
          message: '请输审核/申诉原因',
          trigger: 'blur'
        }]
      },
      downloadLoading: false
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    download: function download() {
      var _this = this;
      this.downloadLoading = true;
      var params = {
        systemStatus: this.searchForm.systemStatus,
        status: this.searchForm.status,
        mobile: this.searchForm.mobile,
        cardNo: this.searchForm.cardNo
      };
      (0, _diamond.exportData)(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '钻石卡申请列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this.downloadLoading = false;
      });
    },
    updateSystemStatus: function updateSystemStatus(status) {
      var _this2 = this;
      (0, _diamond.updateSystemStatus)(status).then(function (res) {
        console.log("res", res);
        _this2.$message.success('操作成功');
        _this2.fetchList();
      }).catch(function (err) {
        _this2.$message.error(err.message || '操作失败');
      });
    },
    toDEtail: function toDEtail(id) {
      this.$emit('viewDetail', id);
    },
    reviewDialog: function reviewDialog(e, status) {
      var _this3 = this;
      var remark2 = '';
      // 重置表单内容
      this.$nextTick(function () {
        if (_this3.$refs.addFormRef) {
          _this3.$refs.addFormRef.resetFields();
        }
      });
      if (status == 1) {
        this.dialogTitle = '审核通过';
        remark2 = '恭喜您审核已通过！您的钻石卡邀请函已发放，请点击领取！';
      } else if (status == 2) {
        this.dialogTitle = '审核不通过';
        // remark2 = '存在异常多次异店/异地下单行为。您可点击上方按钮进行申诉，7日内未申诉，系统将自动为您匹配会员等级与权益，1年内您将不可再次申请。'
      } else if (status == 4) {
        this.dialogTitle = '申诉不通过';
        // remark2 = '经复核，您的账号仍然存在异常多次异店/异地下单行为，您的钻石卡邀请函申请不予通过，系统已自动为您匹配会员等级与权益，本次申诉结束，1年内您将不可再次申请。'
      } else if (status == 5) {
        this.dialogTitle = '申诉通过';
        remark2 = '您的申诉已审核通过，钻石卡邀请函已发放，请点击领取！';
      } else if (status == 7) {
        this.dialogTitle = '降级';
        remark2 = '';
      } else if (status == 8) {
        this.dialogTitle = '审核终止';
        remark2 = '审核期间存在退款行为，您的成长值暂不符合钻石卡邀请函申请条件，符合条件后可再次申请。';
      }
      this.showAddDialog = true;
      this.addForm = _objectSpread(_objectSpread({}, e), {}, {
        remark2: remark2,
        reviewStatus: status
      });
      console.log("e", status, e);
      console.log("this.addForm", this.addForm);
    },
    changeTime: function changeTime(e) {
      console.log(e);
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    fetchList: function fetchList() {
      var _this4 = this;
      this.loading = true;
      (0, _diamond.getList)(this.searchForm).then(function (res) {
        _this4.tableData = res.records || [];
        _this4.searchForm.total = res.total || 0;
      }).finally(function () {
        _this4.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        orderId: '',
        shopId: '',
        memberLv: '',
        isAuth: '',
        type: '',
        page: 1,
        limit: 10,
        total: 0,
        times: ''
      }, this.fetchList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    submitAddForm: function submitAddForm() {
      var _this5 = this;
      this.$refs.addFormRef.validate(function (valid) {
        if (valid) {
          // 提交表单
          console.log('提交的表单数据:', _this5.addForm);
          (0, _diamond.updateStatus)({
            id: _this5.addForm.id,
            status: _this5.addForm.reviewStatus,
            remark: _this5.addForm.remark2
          }).then(function (res) {
            _this5.$message.success('操作成功');
            _this5.fetchList();
          }).catch(function (err) {
            _this5.$message.error(err.message || '操作失败');
          });
          _this5.showAddDialog = false;
        } else {
          console.log('表单验证失败');
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};